import * as yup from 'yup';

export const passwordValidation = yup.object({
  email: yup.string().required('*required').email(),
  password: yup.string().required('*required').min(6)
});

export const resetPasswordValidation = yup.object({
  newPassword: yup
    .string()
    .required('input new password')
    .min(6, 'password must be minimum off 6'),
  confirmPassword: yup
    .string()
    .required('confirm password is required')
    .test(
      'confirm password',
      'password must match',
      (value, context) => context.parent.newPassword === value
    )
});

export const ResetPasswordValidation = yup.object({
  email: yup.string().required('*required').email()
});
